<template>
  <div class="detail-infos-wrap">
    <MultipleFilter
      :options="filterOptions"
      @chacked="mutipleChacked"
      @closeTag="handlecloseTag"
      ref="MultipleFilter"
    ></MultipleFilter>
    <SimpleFilter
      :keywords="keywords"
      @search="handleSearch"
      @issueTime="handleIssue"
      @viewCount="handleView"
      @handleDefault="handleDefault"
    ></SimpleFilter>
    <div class="body-content-wrap">
      <div class="left">
        <div class="spin-wrap" v-if="loading">
          <a-spin :spinning="loading" />
        </div>
        <Empty v-if="isEmpty" class="empty-wrap"></Empty>
        <div class="card-wrap" v-if="!isEmpty && !loading">
          <GoodsCard
            v-for="item in goodsInfos"
            :key="item.id"
            :instance="item"
            @collectStatus="handleCollect"
          ></GoodsCard>
        </div>
        <Pagination :total="total" @pageChange="handleChange"></Pagination>
      </div>

      <div class="right">
        <SideCard></SideCard>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import SimpleFilter from '@/components/common/SimpleFilter'
import GoodsCard from './components/goodsCard.vue'
import SideCard from './components/sideCard.vue'
import MultipleFilter from '@/components/MultipleFilter'
import Empty from '@/components/common/Empty/index'
import { filterOptions } from './config'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { getLicenceInfo, collectTradingInfo } from '@/api/tradingInfos.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      keywords: '', // 检索关键词
      goodsInfos: [],
      filterOptions, // 多选过滤
      params: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      body: {},
      loading: false,
      isEmpty: false,
      searchVal: '', //搜索框值
      datas: '', //多选按钮值
    }
  },
  components: {
    MultipleFilter,
    SimpleFilter,
    Pagination,
    GoodsCard,
    SideCard,
    Empty,
  },
  watch: {
    headSearchValueResult: {
      handler() {
        this.initParams()
        // this.initDefaultValue()

        if (
          Object.keys(this.$route.params).length === 0 ||
          Object.keys(this.$route.params.selectVal).length === 0
        ) {
          this.initDefaultValue()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('headerSearch', ['headSearchValueResult']),
  },
  mounted() {
    // 回显产业分类
    if (
      Object.keys(this.$route.params).length > 0 &&
      Object.keys(this.$route.params.selectVal).length > 0
    ) {
      let selectVal = JSON.parse(this.$route.params.selectVal)

      if (selectVal) {
        setTimeout(() => {
          this.$refs.MultipleFilter.checkTagHandler(selectVal)
        }, 1000)
      }
    }
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    // 初始化关键词、请求体
    initParams() {
      this.keywords = this.headSearchValueResult
      this.body = {
        patentName: this.headSearchValueResult,
      }
    },
    // 初始化方法
    async initDefaultValue() {
      try {
        this.loading = true
        const { data } = await getLicenceInfo(this.params, this.body)
        const rows = this.handlerDateFormat(data.rows)
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.isEmpty = rows.length === 0
        this.total = data.total
        this.goodsInfos = rows
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    mutipleChacked(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name,
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })
      this.datas = datas
      this.body = { patentName: this.searchVal, ...datas }
      this.initDefaultValue()
    },
    // 多选tag处理
    handlecloseTag(result) {
      const datas = {}
      Object.keys(result).forEach((key) => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name,
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })
      this.datas = datas
      this.body = { patentName: this.searchVal, ...datas }
      this.initDefaultValue()
    },
    handleSearch(e) {
      this.searchVal = e
      const params = { patentName: e, ...this.datas }
      this.body = params
      // 更新到vuex中
      // this.updateTabValue({ key: 'result', value: e })
      this.initDefaultValue()
    },
    // 切换页面
    handleChange(e) {
      this.params.pageNum = e
      this.initDefaultValue()
    },
    // 简单筛选恢复默认
    handleDefault() {
      delete this.body.params
      this.initDefaultValue()
    },
    // 发布时间筛选
    handleIssue(e) {
      this.body = { ...this.body, params: { sort: e, sortType: '0' } }
      this.initDefaultValue()
    },
    // 浏览量筛选
    handleView(e) {
      this.body = { ...this.body, params: { sort: e, sortType: '1' } }
      this.initDefaultValue()
    },
    // 处理收藏
    async handleCollect(id, status) {
      if (status) {
        const params = { collectId: id, params: { is_collect: '0' } }
        const { code, msg } = await collectTradingInfo(params)
        this.$apiStatusHandler(code, msg)
        if (code === 200) {
          this.initDefaultValue()
        }
        return
      }
      const params = { collectId: id, params: { is_collect: '1' } }
      const { msg, code } = await collectTradingInfo(params)
      this.$apiStatusHandler(code, msg)
      if (code === 200) {
        this.initDefaultValue()
      }
    },
  },
  destroyed() {
    // 重置vuex中的tab值
    this.updateTabValue({ key: 'result', value: '' })
  },
}
</script>
